import { post, get, patch, formData, clientId } from '../../washtraxClient';

const customerSelect = (data) => {
    return get(`customer/list/for-selection`);
};
export default {
    customerSelect
};